import { forwardRef, useMemo } from "react";
import { Button } from "../ui/button";
import { Bell } from "lucide-react";
import { useNotifications } from "@/hooks/use-notifications";
import { cn } from "@/lib/utils";

interface AlertsButtonProps {
  className?: string;
  onClick?: () => void;
  ref?: React.RefObject<HTMLButtonElement>;
}

export const AlertsButton = forwardRef<HTMLButtonElement, AlertsButtonProps>(
  ({ className, onClick, ...props }, ref) => {
    const notifications = useNotifications();

    const unreadNotificationsCount = useMemo(() => {
      return notifications.filter((notification) => !notification.read_at)
        .length;
    }, [notifications]);

    return (
      <Button
        variant="ghost"
        size="icon"
        className={cn(className, "relative")}
        onClick={onClick}
        ref={ref}
        {...props}
      >
        <Bell className="size-4 text-[currentColor]" />
        {unreadNotificationsCount > 0 && (
          <span className="absolute -top-0 -right-0 bg-red-500 text-white text-xs rounded-full w-4 h-4 flex items-center justify-center">
            {unreadNotificationsCount}
          </span>
        )}
      </Button>
    );
  },
);
